import { render, staticRenderFns } from "./OrderSend.vue?vue&type=template&id=31e00b82&"
import script from "./OrderSend.vue?vue&type=script&lang=ts&"
export * from "./OrderSend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports